import { Component, OnInit } from '@angular/core';
import { DataHelperService } from '../services/data-helper.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

  constructor(public dataHelper: DataHelperService) { }

  ngOnInit(): void {
  }

}
